// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

import { subscribePushNotification, unSubscribePushNotification } from './connectivity/pushnotificationConnect';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(user, config) {

  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA'
          );
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config, user);
      }
    });
  }
}

function registerValidSW(swUrl, config, user) {

  let isSubscribed = false;
  let swRegistration = null;
  let anyReminder = false;

  //user object holds the user's reminder opt-in status as boolean.
  //checking if the user opted-in any of our reminder option
  // if (Object.values(user).some((val) => val === true)) anyReminder = true
  if(user.pushNotificationEnabled){
    anyReminder = true
  }

  if (!('Notification' in window)) {
    console.log('Notifications not supported in this browser')
    return
  }

  function initializeUI() {
    // If user opted-in any of the reminder, get subscription data and send it to the server / database.
    if (anyReminder) {
      swRegistration.pushManager.getSubscription().then((subscription) => {
        isSubscribed = subscription !== null

        if (isSubscribed) {
          updateSubscriptionOnServer(subscription)
        } else {
          subscribeUser()
        }
      })
    } else {
      //If the user outed-out the reminder, unscribe the user.
      unsubscribeUser()
    }
  }

  const applicationServerPublicKey = 'BGH0CGogrwzQ4pnAKEhwLsWOgzZBfA9S-Mwe-ALXH1qgR0ednrbUrRMugQ3xq9wvV6r7f7jZ6CE9ZnV6HvMB7F8'

  function subscribeUser() {
    //Prompt user permission for notification
    Notification.requestPermission((status) => {
      console.log('Notification permission status:', status)
    })
    //If the browser has a permission, process subscribing the user.
    if (Notification.permission === 'granted') {
      const applicationServerKey = urlB64ToUint8Array(
        applicationServerPublicKey
      )
      swRegistration.pushManager
        .subscribe({
          userVisibleOnly: true,
          applicationServerKey: applicationServerKey,
        })
        .then((subscription) => {
          updateSubscriptionOnServer(subscription)

          isSubscribed = true
        })
        .catch((err) => {
          if (Notification.permission === 'denied') {
            console.warn('Permission for notifications was denied')
          } else {
            console.error('Failed to subscribe the user: ', err)
          }
        })
    }
  }

  function unsubscribeUser() {
    let userSubscription
    swRegistration.pushManager
      .getSubscription()
      .then((subscription) => {
        if (subscription) {
          userSubscription = subscription
          return subscription.unsubscribe()
        }
      })
      .catch((err) => {
        console.log('Error unsubscribing', err)
      })
      .then(() => {
      //If user already have subscriotion with the app, remove the data from the database.
        if (userSubscription) {
          updateSubscriptionOnServer(userSubscription, null)
        }
        isSubscribed = false
      })
  }

  async function updateSubscriptionOnServer(
    subscription,
    unsubscribe = 'No'
  ) {
    // Here's where you would send the subscription to the application server/database
    //if the action is subscribe. make POST request to the server with user's subscription data.
    try {
      if (unsubscribe) {
        let payload = {
          subscription: JSON.stringify(subscription),
          userAgent: window.navigator.userAgent,
          appVersion: window.navigator.appVersion,
          platform: window.navigator.platform,
          vendor: window.navigator.vendor
        }
        await subscribePushNotification(payload);

        //if the action is unsubscribe. make DELETE request to remove user's subscription from database.
      } else {
        await unSubscribePushNotification({});
      }
    } catch (error) {
      console.log('Update Subscription failed', error)
    }
  }

  //parsing the VAPID key to correct format.
  function urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
    const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/')

    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
  }

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              console.log(
                'New content is available and will be used when all ' +
                  'tabs for this page are closed. See https://cra.link/PWA.'
              );

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      swRegistration = registration;
      initializeUI();
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
